export default class EditAccessListController {

}
